import { useLocation } from 'react-router-dom'

function useQueryParams() {
  const { search } = useLocation()
  const query = new URLSearchParams(search)

  return {
    hasParams: Array.from(query.keys()).length > 0,
    hasCampaign: (() => {
      const campaign = query.get('utm_campaign')
      return campaign !== null && campaign.trim() !== ''
    })(),
    hasContent: (() => {
      const content = query.get('utm_content')
      return content !== null && content.trim() !== ''
    })(),
    getParams: (key: string) => query.get(key),
    getAllParams: () => Object.fromEntries(query.entries()),
  }
}

export default useQueryParams
